import { TermsAgreementModal } from './TermsAgreementModal';

export default TermsAgreementModal;
